'use strict';

class BrandsController {
  /* @ngInject */
  constructor(BrandsService, $scope, $q) {
    Object.assign(this, {
      BrandsService,
      $scope,
      $q
    });

    this.query = {
      include: [],
      where: {},
      limit: 10,
      page: 1,
      order: 'name ASC'
    };

    this.getBrands();

    this.onPagination = () => {
      this.getBrands();
    };
  }

  getBrands() {
    let qOpts = JSON.parse(JSON.stringify(this.query));
    if (this.whereName) {
      qOpts.where.name = {
        ilike: `%${this.whereName}%`
      };
    }

    let queryReady = this.BrandsService.getModels(qOpts).then(brands => {
      this.brands = brands;
    });
    let countReady = this.BrandsService.getCount(qOpts).then(result => {
      this.brandsCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }
}

export default BrandsController;
